<template>
  <v-card class="my-2  overflow-hidden" outlined>
    <v-expansion-panels
      v-model="expandedSections"
      class="mt-0 px-4"
      flat
      multiple
      value
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="text-caption blue-grey--text text--darken-1 ma-0 pa-0"
          data-testid="teamsDetails-text-leadersCount"
        >
          {{ $t('teams.leaderWithCount', { count: team.leaders.length }) }}
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <Member
            v-for="account in leaders"
            :key="account._id"
            :account="account"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mt-0">
        <v-expansion-panel-header
          class="text-caption blue-grey--text text--darken-1 px-0"
          data-testid="teamsDetails-text-membersCount"
        >
          {{ $t('teams.memberWithCount', { count: activeMembers.length }) }}
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <TeamMembersEmptyState
            v-if="team.members.length === 0"
            :canAddMembers="permissions.editTeamMembers"
            :team="team"
            @updated="$emit('updated')"
          />

          <template v-else>
            <Member
              v-for="account in activeMembers"
              :key="account._id"
              :account="account"
            />

            <template v-if="showDeactivatedMembers">
              <Member
                v-for="account in deactivatedMembers"
                :key="account._id"
                :account="account"
              />
            </template>

            <Button
              v-if="deactivatedMembers.length > 0"
              class="mx-4 my-2"
              color="primary"
              plain
              size="small"
              :text="
                showDeactivatedMembers
                  ? $t('teams.hide_deactivated_members')
                  : $t('teams.show_deactivated_members')
              "
              @click="showDeactivatedMembers = !showDeactivatedMembers"
            />
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import _ from 'lodash'

import userMixin from '@/mixins/userMixin.vue'

import Button from '@/components/UI/Button.vue'
import Member from './Member.vue'
import TeamMembersEmptyState from './TeamMembersEmptyState.vue'

const SECTION_INDEXES = {
  LEADERS: 0,
  MEMBERS: 1,
}

export default {
  name: 'TeamMembers',

  mixins: [userMixin],

  components: {
    Button,
    Member,
    TeamMembersEmptyState,
  },

  props: {
    permissions: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      expandedSections: [SECTION_INDEXES.LEADERS, SECTION_INDEXES.MEMBERS],
      showDeactivatedMembers: false,
    }
  },

  computed: {
    leaders() {
      return _.chain(this.team.leaders)
        .map(account => ({
          ...account,
          fullName: this.getFullName(account),
        }))
        .orderBy(['fullName'])
        .value()
    },

    activeMembers() {
      return _.chain(this.team.members)
        .filter(member => !member.isDeleted)
        .map(account => ({
          ...account,
          fullName: this.getFullName(account),
        }))
        .orderBy(['fullName'])
        .value()
    },

    deactivatedMembers() {
      return _.chain(this.team.members)
        .filter(member => member.isDeleted)
        .map(account => ({
          ...account,
          fullName: this.getFullName(account),
        }))
        .orderBy(['fullName'])
        .value()
    },
  },
}
</script>
